<div class="fixed top-18 right-4 z-5 flex flex-col gap-3 pointer-events-none">
  @for (
    notification of notificationService.notifications();
    track notification.id
  ) {
    <div
      class="bg-white dark:bg-blue-950 text-gray-700 dark:text-white pointer-events-auto w-80 rounded-lg border-l-4 shadow-lg p-4 animate-slide-in"
      [ngClass]="typeClasses(notification.type)"
    >
      <div class="flex items-start justify-between">
        <div class="flex-1">
          <h4 class="font-semibold text-sm">{{ notification.title }}</h4>
          <p class="text-xs mt-1 opacity-90">{{ notification.message }}</p>
        </div>
        <button
          class="ml-3 opacity-70 hover:opacity-100 transition-opacity"
          (click)="notificationService.remove(notification.id)"
        >
          ✕
        </button>
      </div>
    </div>
  }
</div>
